import { __decorate } from "tslib";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatSelectModule, } from "@angular/material/select";
import { MatChipsModule } from "@angular/material/chips";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PageHeadingComponent } from "./components/page-heading/page-heading.component";
import { SearchBarComponent } from "./components/search/search-bar/search-bar.component";
import { SearchActionsComponent } from "./components/search/search-actions/search-actions.component";
import { SearchWithActionsComponent } from "./components/search/search-with-actions/search-with-actions.component";
import { HighlightPipe } from "./pipes/highlight/highlight.pipe";
import { DropDownComponent } from "./components/drop-down/drop-down.component";
import { HighlightWithColumnPipe } from "./pipes/highlight/highlight-with-column.pipe";
import { FilterByComponent } from "./components/filter-by/filter-by.component";
import { MatDialogModule } from "@angular/material/dialog";
import { PopUpComponent } from "./components/pop-up/pop-up.component";
import { SearchByColumnComponent } from "./components/search/search-by-column/search-by-column.component";
import { AlertComponent } from "./components/alert/alert.component";
import { CommonModule, DatePipe } from "@angular/common";
import { PwaInstallBottomSheetComponent } from "./components/pwa-install-bottom-sheet/pwa-install-bottom-sheet.component";
import { PrimaryButtonComponent } from "./components/primary-button/primary-button.component";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { TableComponent } from "./components/table/table.component";
import { TableSearchComponent } from "./components/table-search/table-search.component";
import { SecondaryButtonComponent } from "./components/secondary-button/secondary-button.component";
import { InputComponent } from "./components/input/input.component";
import { MatInputModule } from "@angular/material/input";
import { RecipientSelectComponent } from "./components/recipient-select/recipient-select.component";
import { SaShortDatePipe } from "./pipes/sa-short-date/sa-short-date.pipe";
import { NgPipesModule, UcFirstPipe } from "ngx-pipes";
import { HtmlEditorComponent } from "./components/html-text-editor-field/html-editor.component";
import { TableSortHeaderDirective } from "./directives/table-sort-header.directive";
import { PaginationComponent } from "./components/pagination/pagination.component";
import { DragDropDirective } from "./directives/drag-drop.directive";
import { FormDropDownComponent } from "./components/form-drop-down/form-drop-down.component";
import { DragAndDropComponent } from "./components/drag-and-drop/drag-and-drop.component";
import { ViewApplicationAddNoteComponent } from "../application/view-application/view-application-add-note/view-application-add-note.component";
import { ViewApplicationAdhocComponent } from "../application/view-application/view-application-adhoc/view-application-adhoc.component";
import { ApplicationHistoryComponent } from "./components/application-history/application-history.component";
import { ApplicationExternalLinksComponent } from "./components/application-external-links/application-external-links.component";
import { ContentMenuComponent } from "./components/content-menu/content-menu.component";
import { ApplicationNotesComponent } from "./components/application-notes/application-notes.component";
import { NextStepsComponent } from "./components/next-steps/next-steps.component";
import { RouterModule } from "@angular/router";
import { QuillModule } from "ngx-quill";
import { JsonEditorComponent } from "./components/json-editor/json-editor.component";
import { AttachmentManagerComponent } from "./components/attachment-manager/attachment-manager.component";
import { AddAttachmentMngComponent } from "./components/attachment-manager/add-attachment-mng/add-attachment-mng.component";
import { SeletedAttachmentsMngComponent } from "./components/attachment-manager/seleted-attachments-mng/seleted-attachments-mng.component";
import { AddNewRecipientComponent } from "./components/recipient-select/shared/add-new-recipient/add-new-recipient.component";
import { RecipientListComponent } from "./components/recipient-list/recipient-list.component";
import { RecipientListFilterComponent } from "./components/recipient-list/recipient-list-filter/recipient-list-filter.component";
import { AttachmentMngListComponent } from "./components/attachment-manager/attachment-mng-list/attachment-mng-list.component";
import { AppViewShortDatePipe } from "./pipes/app-view-short-date/app-view-short-date.pipe";
import { MatDividerModule } from "@angular/material/divider";
import { SaLongDatePipe } from "./pipes/sa-long-date/sa-long-date.pipe";
import { RecipientSelectFilterComponent } from "./components/recipient-select/recipient-select-filter/recipient-select-filter.component";
import { ReportManagerComponent } from "./components/report-manager/report-manager.component";
import { ReportFormComponent } from "./components/report-manager/report-form/report-form.component";
import { AttachmentParentFormComponent } from "./components/attachment-manager/attachment-parent-form/attachment-parent-form.component";
import { EditRecipientModalFormComponent } from "./components/recipient-list/edit-recipient-modal-form/edit-recipient-modal-form.component";
import { SendEmailComponent } from "./components/send-email/send-email.component";
import { SendLetterComponent } from "./components/send-letter/send-letter.component";
import { AddAttachmentComponent } from "./components/send-email/add-attachment/add-attachment.component";
import { UtcDatePipe } from "./pipes/utc-date/utc-date.pipe";
import { MapModule } from "../map/map.module";
import { PropertiesAdvancedSearchHostDirective } from "../tabs/properties/shared/directives/properties-advanced-search-host.directive";
import { HideElementDirective } from "./directives/hide-element.directive";
import { ViewApplicationContentMenuComponent } from "./components/view-application-content-menu/view-application-content-menu.component";
import { RefreshComponent } from "../tabs/applications/shared/refresh/refresh.component";
import { ReportCriteriaFormComponent } from "./components/report-form/report-criteria-form/report-criteria-form.component";
import { ReportTypeFormComponent } from "./components/report-form/report-type-form/report-type-form.component";
import { StrategyFinderComponent } from "./components/strategy-finder/strategy-finder.component";
import { SafeUrlPipe } from "./pipes/safe-url-pipe/safe-url.pipe";
import { ReportMngCriteriaFrmComponent } from "./components/report-manager/report-mng-criteria-frm/report-mng-criteria-frm.component";
import { SendSmsComponent } from "./components/send-sms/send-sms.component";
import { RecipientsChipsComponent } from "./components/recipients-chips/recipients-chips.component";
import { AddCommentComponent } from "./components/add-comment/add-comment.component";
import { ViewCommentComponent } from "./components/view-comment/view-comment.component";
import { BulkUpdateTeamComponent } from "./components/bulk-update-team/bulk-update-team.component";
import { FilterPipe } from "./pipes/filter/filter.pipe";
import { NgbAccordionModule } from "@ng-bootstrap/ng-bootstrap";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { CancelApplicationConfirmationComponent } from "./components/view-application-content-menu/cancel-application-confirmation/cancel-application-confirmation.component";
let SharedModule = class SharedModule {
};
SharedModule = __decorate([
    NgModule({
        declarations: [
            HighlightPipe,
            FilterPipe,
            HighlightWithColumnPipe,
            AlertComponent,
            PageHeadingComponent,
            PopUpComponent,
            SearchBarComponent,
            SearchByColumnComponent,
            SearchActionsComponent,
            DropDownComponent,
            FilterByComponent,
            SearchWithActionsComponent,
            PwaInstallBottomSheetComponent,
            PrimaryButtonComponent,
            TableComponent,
            TableSearchComponent,
            SecondaryButtonComponent,
            InputComponent,
            RecipientSelectComponent,
            SaShortDatePipe,
            SaLongDatePipe,
            AppViewShortDatePipe,
            HtmlEditorComponent,
            TableSortHeaderDirective,
            PaginationComponent,
            DragDropDirective,
            FormDropDownComponent,
            DragAndDropComponent,
            ViewApplicationAddNoteComponent,
            ViewApplicationAdhocComponent,
            ApplicationHistoryComponent,
            ApplicationExternalLinksComponent,
            ContentMenuComponent,
            ApplicationNotesComponent,
            NextStepsComponent,
            JsonEditorComponent,
            AttachmentManagerComponent,
            AddAttachmentMngComponent,
            SeletedAttachmentsMngComponent,
            AddNewRecipientComponent,
            RecipientListComponent,
            RecipientListFilterComponent,
            AttachmentMngListComponent,
            RecipientSelectFilterComponent,
            ReportManagerComponent,
            ReportFormComponent,
            AttachmentParentFormComponent,
            EditRecipientModalFormComponent,
            SendEmailComponent,
            SendLetterComponent,
            AddAttachmentComponent,
            PropertiesAdvancedSearchHostDirective,
            HideElementDirective,
            ViewApplicationContentMenuComponent,
            RefreshComponent,
            ReportCriteriaFormComponent,
            ReportTypeFormComponent,
            StrategyFinderComponent,
            ReportMngCriteriaFrmComponent,
            SafeUrlPipe,
            SendSmsComponent,
            RecipientsChipsComponent,
            AddCommentComponent,
            BulkUpdateTeamComponent,
            ViewCommentComponent,
            CancelApplicationConfirmationComponent
        ],
        imports: [
            CommonModule,
            MatSelectModule,
            MatChipsModule,
            MatIconModule,
            MatButtonModule,
            FormsModule,
            MatDialogModule,
            MatTableModule,
            MatPaginatorModule,
            MatInputModule,
            ReactiveFormsModule,
            NgPipesModule,
            RouterModule,
            QuillModule.forRoot(),
            MatDividerModule,
            MapModule,
            NgbAccordionModule,
            NgbModule
        ],
        exports: [
            SafeUrlPipe,
            HighlightPipe,
            FilterPipe,
            SearchWithActionsComponent,
            AlertComponent,
            HighlightWithColumnPipe,
            FilterByComponent,
            SearchByColumnComponent,
            PageHeadingComponent,
            PrimaryButtonComponent,
            TableComponent,
            TableSearchComponent,
            SecondaryButtonComponent,
            InputComponent,
            RecipientSelectComponent,
            RecipientsChipsComponent,
            HtmlEditorComponent,
            PaginationComponent,
            DropDownComponent,
            DragDropDirective,
            FormDropDownComponent,
            DragAndDropComponent,
            ViewApplicationAddNoteComponent,
            ViewApplicationAdhocComponent,
            ApplicationHistoryComponent,
            ApplicationExternalLinksComponent,
            ContentMenuComponent,
            ApplicationNotesComponent,
            NextStepsComponent,
            JsonEditorComponent,
            AttachmentManagerComponent,
            SeletedAttachmentsMngComponent,
            RecipientListComponent,
            ReportManagerComponent,
            SearchBarComponent,
            SearchActionsComponent,
            SendEmailComponent,
            SendLetterComponent,
            HideElementDirective,
            RefreshComponent,
            ReportCriteriaFormComponent,
            ReportTypeFormComponent,
            SaShortDatePipe,
            SendSmsComponent,
            AddCommentComponent,
            BulkUpdateTeamComponent,
            ViewCommentComponent,
        ],
        providers: [
            SaShortDatePipe,
            AppViewShortDatePipe,
            UcFirstPipe,
            SaLongDatePipe,
            UtcDatePipe,
            DatePipe
        ]
    })
], SharedModule);
export { SharedModule };
